import {Component, HostListener, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {ActivityDialogsComponent} from "./activity-dialogs/activity-dialogs.component";
import {CREDIT_CARDS_DIALOG, REQUEST_PAYMENT_DIALOG} from "../constants/global.constants";
import {TransactionService} from "../service/transaction.service";
import {TeamService} from "../service/team.service";
import {PaymentTransactionsResponse} from "../models/paymentTransactions .model";
import {SharedConstants} from "../utilityClass/sharedConstants";
import {UserService} from "../service/user.service";
import {ActivityFactory} from "./activity-factory.service";
import {SharedService} from "../service/shered.service";
import {UserResponse} from "../interface/userResponse";
import {Team} from "../interface/team";
import {MatDateRangePicker} from "@angular/material/datepicker";
import {DatePipe} from "@angular/common";
import {PaymentTransactionFilterModel} from "../interface/paymentTransactionFilterModel ";
import {AbstractControl, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {TransactionAndTransferInfoModel} from "../models/transactionAndTransferInfo.model";
import {BalanceFormatterUtil} from "./balance-formatter-util ";
import {ActivityTabs} from "../enums/activity-tabs";
import {ALLOWED_KEYS} from "../constants/deleteProfileCards.constant";
import {ActivityFilterFormValue, DEFAULT_ACTIVITY_FILTER_FORM_VALUE} from "../interface/activityFilterFormValue";
import {Page} from "../interface/hashtag";
import {LanguageService} from "../service/language.service";
import {Subscription} from "rxjs";
import {CommissionUnit} from "../enums/commission-unit";

@Component({
  selector: 'app-activity',
  templateUrl: './activity.component.html',
  styleUrl: './activity.component.scss'
})
export class ActivityComponent implements OnInit, OnDestroy {
  activeTab = ActivityTabs.ALL_INDIVIDUAL;
  selectedTab: string = SharedConstants.ALL;
  searchQuery: string = '';
  allPaymentTransactions: TransactionAndTransferInfoModel[] = []
  transactionsAndTransfers!: PaymentTransactionsResponse
  currentUser !: UserResponse
  currentTeam!: Team
  filterForm!: FormGroup;
  menuOpen = false
  private savedFilterFormValue: ActivityFilterFormValue = {...DEFAULT_ACTIVITY_FILTER_FORM_VALUE};
  lastFourNumbers!: string
  isNewTransactions: boolean = false
  currency = SharedConstants.CURRENCY
  currentPage: number = 0;
  selectedTeamId = 0
  pageSize: number = 10;
  trimmedQuery!: string
  totalRecords: number = 0;
  filterPayload!: PaymentTransactionFilterModel | null
  isMenuOpen = false;
  teams: Team[] = []
  selectedTeam!: Team | null
  private languageSubscription?: Subscription;
  balance!: number
  totalPages: number = 0;
  isLoading: boolean = false;
  hasNoData: boolean = true;
  currentLang: string = '';

  protected readonly BalanceFormatterUtil = BalanceFormatterUtil;

  constructor(private dialog: MatDialog,
              private transactionService: TransactionService,
              private teamService: TeamService,
              private userService: UserService,
              private sharedService: SharedService,
              private fb: FormBuilder,
              private renderer: Renderer2,
              private languageService: LanguageService) {
    ActivityFactory.isIndividualActive.subscribe({
      next: (isIndividualActive: string) => {
        this.activeTab = isIndividualActive as ActivityTabs;
      }
    })
  }

    ngOnDestroy(): void {
    this.languageSubscription?.unsubscribe();
  }


  ngOnInit(): void {
    this.currentLang = this.languageService.getCurrentLanguage();

    this.languageSubscription = this.languageService.currentLanguage$.subscribe({
      next: (lang: string) => {
        this.currentLang = lang;
        this.getIndividualPaymentTransactions();
        if (this.currentTeam) {
          this.getCurrentUserTeam();
        }
      }
    });

    this.getIndividualPaymentTransactions()
    this.getCurrentUserTeam()
    this.sharedService.updateActivities.subscribe({
      next: (_: any) => {
        if (ActivityFactory.currentTeam.value){
          this.currentTeam = ActivityFactory.currentTeam.value
        }
        if (ActivityFactory.selectedTeam.value) {
          this.selectTeam(ActivityFactory.selectedTeam.value)
          this.selectedTeam = ActivityFactory.selectedTeam.value
        }else {
          this.toggleIndividual( ActivityFactory.isIndividualActive.value)
        }
      }
    })
    this.filterForm = this.fb.group(
      {
        status: [''],
        amountFrom: [''],
        amountTo: [''],
        dateRange: this.fb.group({
          startDate: [null],
          endDate: [null]
        })
      },
      {validator: this.amountRangeValidator}
    );
  }

  amountRangeValidator(form: AbstractControl) {
    const amountFrom = form.get('amountFrom')?.value;
    const amountTo = form.get('amountTo')?.value;
    if (amountFrom !== 0 && amountTo > 0  && amountTo < amountFrom) {
      return { amountInvalid: true };
    }
    return null;
  }

  getTeamsForCurrentUserAsMember() {
    if (!this.currentTeam.requestAllowed){
      this.teamService.getAllTeamsByCurrentMember().subscribe({
        next: (teams) => {
          this.teams = teams;
        }
      })
    }else {
      this.teamService.getTeamsByCurrentMember().subscribe({
        next: (teams) => {
          this.teams = teams;
        }
      })
    }
  }

  selectTab(tab: string) {
    this.selectedTab = tab;
    this.handlePaymentTransaction(this.currentPage, this.pageSize, this.trimmedQuery)
  }

  openRequestPaymentDialog(): void {
    const dialogData: any = {
      message: REQUEST_PAYMENT_DIALOG,
      balance: this.transactionsAndTransfers?.balance
    };
    if (this.isRequestPaymentEnabled()) {
      dialogData.activeTab = this.activeTab
    }

    if (this.activeTab === ActivityTabs.MY_TEAM) {
      dialogData.teamId = this.currentTeam?.id;
    }
    if (this.activeTab === ActivityTabs.ALL_TEAMS) {
      dialogData.teamId = this.selectedTeam?.id;
    }
    const dialogRef = this.dialog.open(ActivityDialogsComponent, {
        width: '430px',
        data: dialogData
      }
    );

    dialogRef.afterClosed().subscribe({
      next: (res) => {
        this.resetTransactions()
        this.handleDialogClose(res)
        this.handlePaymentTransaction(this.currentPage,this.pageSize, this.trimmedQuery)
      }
    });
  }

  openCreditCardsDialog() {
    const dialogRef = this.dialog.open(ActivityDialogsComponent, {
        width: '430px',
        data: {
          message: CREDIT_CARDS_DIALOG,
          isFromBankAccount: true
        }
      }
    );

    dialogRef.afterClosed().subscribe({
      next: (res) => {
        this.handleDialogClose(res)
      }
    });
  }

  toggleIndividual(activeTab: string) {
    this.activeTab = activeTab as ActivityTabs;
    this.selectedTeam = null
    ActivityFactory.isIndividualActive.next(activeTab)
    this.selectedTab = SharedConstants.ALL
    if (activeTab === ActivityTabs.ALL_TEAMS) {
      this.isMenuOpen = !this.isMenuOpen
    } else {
      this.resetTransactions();
      this.handlePaymentTransaction(this.currentPage, this.pageSize)
    }
  }

  resetDateRange(picker: MatDateRangePicker<any>) {
    this.filterForm.get('dateRange')?.reset()
    picker.close();
  }

  filter() {
    if (this.filterForm.dirty) {
      const formData = this.filterForm.value;
      this.savedFilterFormValue = formData;
      this.filterPayload = {
        status: formData.status ? formData.status : null,
        amountFrom: formData.amountFrom,
        amountTo: formData.amountTo,
        startDate: this.formatDate(formData.dateRange.startDate),
        endDate: this.formatDate(formData.dateRange.endDate),
        selectedTab: this.selectedTab
      };
      if (this.activeTab === ActivityTabs.ALL_INDIVIDUAL) {
        this.transactionService.filterIndividualPaymentTransactions(this.filterPayload, this.currentPage, this.pageSize, this.currentUser.id).subscribe({
          next: (transactions) => {
            this.totalRecords = transactions.totalElements
            this.allPaymentTransactions = [...this.allPaymentTransactions, ...transactions.content];
            this.totalPages = transactions.totalPages;
          }
        })
      } else if (this.activeTab === ActivityTabs.MY_TEAM) {
        this.transactionService.filterAllTeamsIndividualPaymentTransactions(this.filterPayload, this.currentPage, this.pageSize, this.currentTeam.id).subscribe({
          next: (transactions) => {
            this.allPaymentTransactions = [...this.allPaymentTransactions, ...transactions.content];
            this.totalRecords = transactions.totalElements
            this.totalPages = transactions.totalPages;
          }
        })
      } else if (this.selectedTeam) {
        this.transactionService.filterMyTeamIndividualPaymentTransactions(this.currentUser.id, this.filterPayload, this.currentPage, this.pageSize, this.selectedTeam.id).subscribe({
          next: (transactions) => {
            this.allPaymentTransactions = [...this.allPaymentTransactions, ...transactions.content];
            this.totalRecords = transactions.totalElements
            this.totalPages = transactions.totalPages;
          }
        })
      }
    }
  }

  formatDate(date: Date): string | null {
    if (!date) return null;

    const datePipe = new DatePipe('en-US');
    return datePipe.transform(date, 'dd.MM.yyyy');
  }

  reset() {
    this.filterForm.reset()
    this.savedFilterFormValue = {...DEFAULT_ACTIVITY_FILTER_FORM_VALUE}
    this.filterPayload = null
    this.handlePaymentTransaction(this.currentPage, this.pageSize)
  }

  search() {
    this.allPaymentTransactions = []
    this.trimmedQuery = this.searchQuery.trim();
    const isQueryValid = this.trimmedQuery.length > 2;
    const queryParam = isQueryValid ? this.trimmedQuery : undefined;

    switch (this.activeTab) {
      case ActivityTabs.MY_TEAM:
        this.handleMyTeamTab(this.currentTeam.id, this.currentPage, this.pageSize, queryParam);
        break;

      case ActivityTabs.ALL_TEAMS:
        this.handleAllTeamTab(this.currentPage, this.pageSize, queryParam);
        break;

      default:
        this.handleIndividualTab(this.currentPage, this.pageSize, queryParam);
        break;
    }
  }

  getLastFourDigits(accountNumber: string): string {
    if (accountNumber && accountNumber.length > 4) {
      return accountNumber.slice(-4);
    }
    return ""
  }

  changeTransactionsIsSeen() {
    this.isNewTransactions = false
    if (this.activeTab === ActivityTabs.MY_TEAM) {
      this.transactionService.changeTransactionsIsSeenForMyTeam(this.currentTeam.id).subscribe({
        next: () => {}
      })
    } else if (this.activeTab === ActivityTabs.ALL_TEAMS) {
      if (this.selectedTeam) {
        this.transactionService.changeTransactionsIsSeenForSelectedTeam(this.selectedTeam.id, this.currentUser.id).subscribe({
          next: () => {}
        })
      }
    } else {
      this.transactionService.changeTransactionsIsSeen(this.currentUser.id).subscribe({
        next: () => {}
      })
    }
  }

  onMenuOpened(): void {
    this.savedFilterFormValue = this.filterForm.value;
    const overlayContainer = this.renderer.selectRootElement('.cdk-overlay-container', true);

    if (overlayContainer) {
      this.renderer.setStyle(overlayContainer, 'z-index', '1001');
    }
  }

  onMenuClosed(): void {
    this.filterForm.setValue(this.savedFilterFormValue);
    const overlayContainer = this.renderer.selectRootElement('.cdk-overlay-container', true);
    if (overlayContainer) {
      this.renderer.removeStyle(overlayContainer, 'z-index');
    }
  }

  openAddCreditCardDialog() {
    const dialogRef = this.dialog.open(ActivityDialogsComponent, {
      width: '430px',
      data: {
        message: CREDIT_CARDS_DIALOG,
      }
    })

    dialogRef.afterClosed().subscribe({
      next: (res) => {
        this.handleDialogClose(res)
      }
    });
  }

  isRequestPaymentEnabled(): boolean {
    return (
      this.activeTab === ActivityTabs.ALL_INDIVIDUAL ||
      (this.currentTeam?.requestAllowed ?? false) ||
      (!!this.selectedTeam && !this.selectedTeam.requestAllowed)
    );
  }

  selectTeam(team: Team) {
    this.resetTransactions()
    this.selectedTeam = team
    this.isMenuOpen = !this.isMenuOpen
    this.selectedTeamId = team.id
    this.handleAllTeamTab(this.currentPage, this.pageSize, this.trimmedQuery);
  }

  calculateCommission(amount: number, commission: number, userCardCommission: number, commissionUnit: string | null, standardCommission: number | null): number {
    if (commissionUnit === CommissionUnit.PERCENT) {
      return userCardCommission ? userCardCommission : 0;
    }
    if (standardCommission != null) return standardCommission;
    if (commission) return commission;
    return 0;
  }

  getCommissionSymbol(commissionUnit: string | null): string {
    return commissionUnit === CommissionUnit.PERCENT ? '%' : String(this.currency);
  }

  calculateAmount(transferInfoModel: TransactionAndTransferInfoModel): number {
    const {amount, paymentMethod, standardCommission} = transferInfoModel;
    if (paymentMethod == SharedConstants.TRANSFER) {
      return amount;
    }
    return standardCommission != null ? amount + standardCommission : amount;
  }

  allowOnlyNumbers(event: KeyboardEvent): void {
    if (!ALLOWED_KEYS.test(event.key)) {
      event.preventDefault();
    }
  }

  resetTransactions(): void {
    this.allPaymentTransactions = [];
    this.currentPage = 0;
  }

  @HostListener('window:scroll', ['$event'])
  private onScroll() {
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 100 && !this.isLoading) {
      this.loadMore();
    }
  }

  loadMore() {
    if (this.currentPage < this.totalPages - 1) {
      this.currentPage++;
      this.processFilterOrTransaction()
    }
  }

  private updateTransactionData(res: PaymentTransactionsResponse): void {
    this.transactionsAndTransfers = res;
    this.totalRecords = res.allTransactions.totalElements;
    this.balance = res.balance;
    this.allPaymentTransactions = [...this.allPaymentTransactions, ...res.allTransactions.content];
    this.totalPages = res.allTransactions.totalPages;
    this.isNewTransactions = res.isAdminSeen
  }

  private processFilterOrTransaction() {
    if (this.filterForm.dirty) {
      this.filter();
    } else {
      this.handlePaymentTransaction(this.currentPage, this.pageSize, this.trimmedQuery);
    }
  }

  private handleDialogClose(res: any): void {
    if (res) {
      this.lastFourNumbers = this.getLastFourDigits(res.accountNumber);
    }
  }

  private handlePaymentTransaction(currentPage: number, pageSize: number, trimmedQuery?: string): void {
    if (this.activeTab === ActivityTabs.ALL_INDIVIDUAL) {
      this.handleIndividualTab(currentPage, pageSize, trimmedQuery);
    } else if (this.activeTab === ActivityTabs.MY_TEAM) {
      this.handleMyTeamTab(this.currentTeam.id, currentPage, pageSize, trimmedQuery);
    } else if (this.activeTab === ActivityTabs.ALL_TEAMS) {
      this.handleAllTeamTab(currentPage, pageSize, trimmedQuery);
    }
  }

  private handleIndividualTab(currentPage: number, pageSize: number, trimmedQuery?: string) {
    if (this.filterPayload) {
      this.filter();
    } else {
      switch (this.selectedTab) {
        case SharedConstants.ALL:
          this.getAllTransactions(this.currentUser.id, currentPage, pageSize, trimmedQuery)
          this.totalRecords = this.transactionsAndTransfers.allTransactions.totalElements
          break;
        case SharedConstants.INCOMING:
          this.getIncomingTransactions(currentPage, pageSize, trimmedQuery);
          break;
        case SharedConstants.BALANCE_TRANSFER:
          this.getRequestsTransfers(currentPage, pageSize, trimmedQuery)
          break;

      }
    }
  }

  private handleMyTeamTab(teamId: number, currentPage: number, pageSize: number, trimmedQuery?: string) {
    if (this.filterPayload) {
      this.filter();
    } else {
      switch (this.selectedTab) {
        case SharedConstants.ALL:
          this.getTransactionsForMyTeam(teamId, currentPage, pageSize, trimmedQuery)
          this.totalRecords = this.transactionsAndTransfers.allTransactions.totalElements
          break;
        case SharedConstants.INCOMING:
          this.getIncomingTransactionsForMyTeam(teamId, currentPage, pageSize, trimmedQuery);
          break;
        case SharedConstants.BALANCE_TRANSFER:
          this.getRequestsTransfersForMyTeam(currentPage, pageSize, trimmedQuery)
          break;

      }
    }
  }

  private handleAllTeamTab(currentPage: number, pageSize: number, trimmedQuery?: string) {
    if (this.selectedTeam) {
      if (this.filterPayload) {
        this.filter();
      } else {
        switch (this.selectedTab) {
          case SharedConstants.ALL:
            this.getTransactionsForSelectedTeam(this.selectedTeam.id, this.currentUser.id, currentPage, pageSize, trimmedQuery)
            this.totalRecords = this.transactionsAndTransfers.allTransactions.totalElements
            break;
          case SharedConstants.INCOMING:
            this.getIncomingTransactionsForSelectedTeam(this.selectedTeam.id, this.currentUser.id, currentPage, pageSize, trimmedQuery);
            break;
          case SharedConstants.BALANCE_TRANSFER:
            this.getRequestsTransfersForSelectedTeam(this.selectedTeam.id, this.currentUser.id, currentPage, pageSize, trimmedQuery)
            break;

        }
      }
    }
  }

  private getCurrentUserTeam() {
    this.teamService.getCurrentUserTeam().subscribe({
      next: (team) => {
        if (team){
          this.currentTeam = team
          this.getTeamsForCurrentUserAsMember()
        }
      }
    })
  }

  private getIndividualPaymentTransactions(trimmedQuery?: string) {
    this.userService.currentUser.subscribe({
      next: (response) => {
        this.currentUser = response

        if (this.currentUser.bankCards?.length) {
          this.lastFourNumbers = this.getLastFourDigits(this.currentUser.bankCards[0].accountNumber)
        }
        this.getAllTransactions(response.id, this.currentPage, this.pageSize, trimmedQuery)
      }
    })
  }

  private getAllTransactions(id: BigInt, currentPage: number, pageSize: number, trimmedQuery?: string) {
    this.transactionService.getAllIndividualPaymentTransactions(id, currentPage, pageSize, trimmedQuery).subscribe({
      next: (transactions) => {
        if (transactions) {
          this.updateTransactionData(transactions);
          this.hasNoData = false
        }
      }
    })
  }

  private getTransactionsForMyTeam(teamId: number, currentPage: number, pageSize: number, trimmedQuery?: string) {
    this.transactionService.getMyTeamAllPaymentTransactions(teamId, currentPage, pageSize, trimmedQuery).subscribe({
      next: (transactions) => {
        this.updateTransactionData(transactions);
      }
    })
  }

  private getTransactionsForSelectedTeam(teamId: number, currentUserId: bigint, currentPage: number, pageSize: number, trimmedQuery?: string) {
    this.transactionService.getSelectedTeamAllPaymentTransactions(teamId, currentUserId, currentPage, pageSize, trimmedQuery).subscribe({
      next: (transactions) => {
        this.updateTransactionData(transactions);
      }
    })
  }

  private getRequestsTransfers(currentPage: number, pageSize: number, trimmedQuery?: string) {
    this.transactionService.getRequestsTransfers(this.currentUser.id, currentPage, pageSize, trimmedQuery).subscribe({
      next: (transactions) => {
        this.processTransactionResults(transactions);
      }
    })
  }

  private getRequestsTransfersForMyTeam(currentPage: number, pageSize: number, trimmedQuery?: string) {
    this.transactionService.getRequestsTransfersForMyTeam(this.currentTeam.id, currentPage, pageSize, trimmedQuery).subscribe({
      next: (transactions) => {
        this.processTransactionResults(transactions);
      }
    })
  }

  private getRequestsTransfersForSelectedTeam(teamId: number, currentUserId: bigint, currentPage: number, pageSize: number, trimmedQuery?: string) {
    this.transactionService.getRequestsTransfersForSelectedTeam(teamId, currentUserId, currentPage, pageSize, trimmedQuery).subscribe({
      next: (transactions) => {
        this.processTransactionResults(transactions);
      }
    })
  }

  private getIncomingTransactions(currentPage: number, pageSize: number, trimmedQuery?: string) {
    this.transactionService.getIncomingTransactions(this.currentUser.id, currentPage, pageSize, trimmedQuery).subscribe({
      next: (transactions) => {
        this.processTransactionResults(transactions);
      }
    })
  }

  private processTransactionResults(transactions: Page<TransactionAndTransferInfoModel>): void {
    this.totalRecords = transactions.totalElements;
    this.allPaymentTransactions = [...this.allPaymentTransactions, ...transactions.content];
    this.totalPages = transactions.totalPages;
  }

  private getIncomingTransactionsForMyTeam(teamId: number, currentPage: number, pageSize: number, trimmedQuery?: string) {
    this.transactionService.getIncomingTransactionsForMyTeam(teamId, currentPage, pageSize, trimmedQuery).subscribe({
      next: (transactions) => {
        this.processTransactionResults(transactions);
      }
    })
  }

  private getIncomingTransactionsForSelectedTeam(teamId: number, currentUserId: bigint, currentPage: number, pageSize: number, trimmedQuery?: string) {
    this.transactionService.getIncomingTransactionsForSelectedTeam(teamId, currentUserId, currentPage, pageSize, trimmedQuery).subscribe({
      next: (transactions) => {
        this.processTransactionResults(transactions);
      }
    })
  }

  get uniquePaymentTransactions(): TransactionAndTransferInfoModel[] {
    const seen = new Set<number>();
    return this.allPaymentTransactions.filter(transaction => {
      if (seen.has(transaction.id)) {
        return false;
      }
      seen.add(transaction.id);
      return true;
    });
  }

  protected readonly SharedConstants = SharedConstants;
  protected readonly ActivityTabs = ActivityTabs;
  protected readonly ActivityFactory = ActivityFactory;
}
